/**
 * @generated SignedSource<<dda74bcbd3084ffaf13348ec0a60df36>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRespLinksBlock_item$data = {
  readonly popularSearchesLink: {
    readonly " $fragmentSpreads": FragmentRefs<"SharedPopularSearchesLink_popularSearchesLink">;
  };
  readonly sitemapLinks: ReadonlyArray<{
    readonly text: string | null;
  }> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSitemapLinks_item">;
  readonly " $fragmentType": "SharedRespLinksBlock_item";
};
export type SharedRespLinksBlock_item$key = {
  readonly " $data"?: SharedRespLinksBlock_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRespLinksBlock_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "popularSearchesLink",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SharedPopularSearchesLink_popularSearchesLink"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "sitemapLinks",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSitemapLinks_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "7094f7232df8a553bf49c4a8bd6aab8c";

export default node;
